export default __webpack_public_path__ + "static/media/experiance.d94e3673.svg";